import { Component, inject, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nService } from '../../core/i18n.service';
import { TranslationKey } from '../../core/i18n.translations';

interface AgentMessage {
  id: number;
  mine: boolean;
  textKey?: TranslationKey;
  text?: string;
}

@Component({
  standalone: true,
  selector: 'app-ai-agent',
  imports: [FormsModule],
  templateUrl: './ai-agent.component.html',
  styleUrl: './ai-agent.component.scss',
})
export class AiAgentComponent {
  protected readonly i18n = inject(I18nService);
  readonly embeddedDesktop = input(false);
  protected readonly draft = signal('');
  protected readonly messages = signal<AgentMessage[]>([
    {
      id: 1,
      mine: false,
      textKey: 'aiAgent.welcomeMessage',
    },
  ]);
  protected readonly suggestions: TranslationKey[] = [
    'aiAgent.suggestionSearch',
    'aiAgent.suggestionEstimate',
    'aiAgent.suggestionListing',
  ];

  protected useSuggestion(key: TranslationKey): void {
    this.draft.set(this.i18n.t(key));
  }

  protected onDraftChange(value: string): void {
    this.draft.set(value);
  }

  protected sendMessage(): void {
    const text = this.draft().trim();
    if (!text) {
      return;
    }

    const nextId = Date.now();
    this.messages.update((messages) => [
      ...messages,
      { id: nextId, mine: true, text },
      { id: nextId + 1, mine: false, textKey: 'aiAgent.autoReply' },
    ]);
    this.draft.set('');
  }

  protected messageText(message: AgentMessage): string {
    return message.text ?? (message.textKey ? this.i18n.t(message.textKey) : '');
  }
}
